import { useUsuarioStore } from "../../stores/usuarioStore"

export const prefetchUsuariosPagina = (oUsuario) => {
  if (!oUsuario?.id) return

  import(/* webpackPrefetch: true */ "../../pages/Users")

  useUsuarioStore.getState().paginadaObter({
    searchParam: "",
    pageNumber: 1,
  })
}
